<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_vii"></a>Contents</h2>
<p class="toc-entry"><a href="#/xhtml/frontmatter01#frontmatter01">Acknowledgments</a></p>
<p class="toc-entry"><a href="#/xhtml/frontmatter02#frontmatter02">Preface</a></p>
<p class="toc-entry1"><a href="#/xhtml/part01#part01"><strong>The Production Code 1922–1934</strong></a></p>
<p class="toc-entry"><a href="#/xhtml/chapter01#chapter01">1. Welcome Will Hays!</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter02#chapter02">2. Welcome Mae West!</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter03#chapter03">3. Welcome Joe Breen!</a></p>
<p class="toc-entry1"><span href="#/xhtml/part02#part02" title="Link target outside of Sample"><strong>The Production Code Administration 1934–1966</strong></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter04#chapter04" title="Link target outside of Sample">4. <em>Dead End</em></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter05#chapter05" title="Link target outside of Sample">5. <em>Gone With the Wind</em></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter06#chapter06" title="Link target outside of Sample">6. <em>The Outlaw</em> and <em>The Postman Always Rings Twice</em></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter07#chapter07" title="Link target outside of Sample">7. <em>The Bicycle Thief</em></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter08#chapter08" title="Link target outside of Sample">8. <em>Detective Story</em> and <em>A Streetcar Named Desire</em></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter09#chapter09" title="Link target outside of Sample">9. <em>The Moon Is Blue</em> and <em>The French Line</em></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter10#chapter10" title="Link target outside of Sample">10. <em>Lolita</em></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter11#chapter11" title="Link target outside of Sample">11. <em>Who’s Afraid of Virginia Woolf?</em></span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter01#backmatter01" title="Link target outside of Sample">Aftermath</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter02#backmatter02" title="Link target outside of Sample">Appendix: The Motion Picture Production Code</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter03#backmatter03" title="Link target outside of Sample">Notes</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter04#backmatter04" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter05#backmatter05" title="Link target outside of Sample">Selected Filmography</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter06#backmatter06" title="Link target outside of Sample">About the Authors</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter07#backmatter07" title="Link target outside of Sample">Index</span></p>
<p class="toc-entry2"><span href="#/xhtml/chapter09#figures" title="Link target outside of Sample"><em>Illustrations</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?647687cc